<ng-container *transloco="let convert;">
  <app-modal [modalId]="modalId">
    @if (!waitingResponse && !successfulResponse) {
      <header class="modal__header">
        <h1
          data-testid="edit-delivery-modal-title"
          class="modal__title"
          [attr.id]="modalId + '-title'"
          tabindex="-1"
          (keydown.arrowUp)="focusToElem('close')"
          (keydown.arrowDown)="focusToElem('radioYes')"
          #headerEdit
          >
          {{ convert('vehicles.editDeliveryModal.textEnterprise') }}
        </h1>
      </header>
      @if (errorMessage) {
        <div class="mt-2">
          @if (errorMessage) {
            <p data-testid="edit-delivery-modal-error-text" class="mb-0 text-danger fw-bold">{{ errorMessage }}</p>
          }
        </div>
      }
      <div class="modal__content delivery_options">
        <div class="control-wrapper">
          <div class="custom-control custom-radio custom-control-inline ">
            <input
              data-testid="edit-delivery-modal-yes-radio"
              type="radio"
              id="do_yes_checkbox"
              name="delivery-radios"
              class="custom-control-input delivery_options__rows--input"
              [checked]="deliveryOption"
              (change)="setDeliveryValue(true)"
              value="1"
              (keydown.arrowUp)="focusToElem('header')"
              (keydown.arrowDown)="focusToElem('radioNo')"
              #radioYes
              />
            <label class="custom-control-label delivery_options__label" for="do_yes_checkbox">{{ convert('vehicles.editDeliveryModal.labelYes') }}</label>
          </div>
        </div>
        <div class="control-wrapper delivery_options__row">
          <div class="custom-control custom-radio custom-control-inline ">
            <input
              data-testid="edit-delivery-modal-no-radio"
              type="radio"
              id="do_no_checkbox"
              name="delivery-radios"
              class="custom-control-input delivery_options__rows--input"
              [checked]="!deliveryOption"
              value="false"
              (change)="setDeliveryValue(false)"
              (keydown.arrowUp)="focusToElem('radioYes')"
              (keydown.arrowDown)="focusToElem('submit')"
              #radioNo
              />
            <label class="custom-control-label delivery_options__label" for="do_no_checkbox">{{ convert('vehicles.editDeliveryModal.labelNo') }}</label>
          </div>
        </div>
      </div>
      <div class="modal__action">
        <button
          data-testid="edit-delivery-modal-save-button"
          class="btn btn-primary bid-buttons action-btns"
          (click)="changeDeliveryOption()"
          data-track-elem="button"
          data-track-name="Save"
          (keydown.arrowDown)="focusToElem('cancel')"
          (keydown.arrowUp)="focusToElem('radioNo')"
          id="do_save_button"
          [disabled]="isViewOnlyRole"
          #submitSave
          >
          {{ convert('common.btnSave') }}
        </button>
        <button
          data-testid="edit-delivery-modal-cancel-button"
          class="btn btn-link cancel-btn bid-buttons action-btns"
          (click)="cancel()"
          data-track-elem="button"
          data-track-name="Cancel"
          data-track-trigger="close"
          (keydown.arrowDown)="focusToElem('close')"
          (keydown.arrowUp)="focusToElem('submit')"
          id="do_cancel_button"
          #cancelSave
          >
          {{ convert('common.btnCancel') }}
        </button>
      </div>
      <div class="modal-close-container">
        <button
          data-testid="edit-delivery-modal-close-button"
          class="modal__close"
          [attr.aria-label]="convert('common.modalClose')"
          (click)="cancel()"
          data-track-elem="icon"
          data-track-name="Close"
          data-track-trigger="close"
          (keydown.arrowDown)="focusToElem('header')"
          (keydown.arrowUp)="focusToElem('cancel')"
          id="do_close_x_button"
          #closeButton
          >
          <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
        </button>
      </div>
    }

    @if (waitingResponse && !successfulResponse) {
      <!-- submitting -->
      <app-action-submitting data-testid="edit-delivery-modal-submitting" actionText="{{ convert('vehicles.editDeliveryModal.actionTextSavingDelivery') }}"></app-action-submitting>
    }

    @if (!waitingResponse && successfulResponse) {
      <!-- success -->
      <app-action-submitted (close)="cancel()" actionText="{{ convert('vehicles.editDeliveryModal.actionTextDeliverySaved') }}" [tenantName]="tenantName">
      </app-action-submitted>
    }
  </app-modal>
</ng-container>
